// removed by extract-text-webpack-plugin
module.exports = {"searchBox":"searchBox_HomeSearchBox"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomePageV2/components/HomeSearchBox/HomeSearchBox.scss
// module id = 255
// module chunks = 0